import { useDispatch } from "react-redux";
import { Divider, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

import { POSTCODE } from "../../../consts/strings";
import { palette } from "../../../theme/palette";

import { Postcode } from "../../../utils/postcode";

import { searchHandler } from "../../../reducers/ownApp/thunkActions";

import { View } from "../../View";
import { BaseSummaryPopover } from "../Base/BaseSummaryPopover";

const useStyles = makeStyles(() => ({
  postcodeLine: {
    fontWeight: "bold",
    color: palette.typography.black.solid,
  },
  postcode: {
    textDecorationLine: "underline",
    cursor: "pointer",
  },
  row: {
    display: "flex",
    lineHeight: "30px",
  },
  left: {
    flex: 1,
  },
  divider: {
    height: "1px",
    background: palette.typography.black.neutral,
  },
}));

const OverrideConflictsPopover = ({
  overridesConflictsAreas,
  open,
  anchorEl,
  onClose,
}) => {
  const styles = useStyles();
  const dispatch = useDispatch();

  const goToPostcode = (postcode) => {
    onClose();
    dispatch(
      searchHandler({
        item: {
          type: Postcode.toLevel(postcode),
          value: postcode,
        },
        type: POSTCODE,
      })
    );
  };

  return (
    <BaseSummaryPopover
      id={"overrideConflictsPopover"}
      title={"Postcode Conflicts"}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      width={"160px"}
    >
      {overridesConflictsAreas.map((postcode) => (
        <View key={postcode}>
          <View className={clsx(styles.row, styles.postcodeLine)}>
            <View className={styles.left}>
              <Typography
                className={styles.postcode}
                onClick={() => goToPostcode(postcode)}
              >
                {postcode}
              </Typography>
            </View>
          </View>
          <Divider className={styles.divider} />
        </View>
      ))}
    </BaseSummaryPopover>
  );
};

export default OverrideConflictsPopover;
